"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const form_part_module_scss_1 = __importDefault(require("./form-part.module.scss"));
const FormPart = (_a) => {
    var { className = "", forId, label, tipText = "", errorMsg = "", children } = _a, props = __rest(_a, ["className", "forId", "label", "tipText", "errorMsg", "children"]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(className, form_part_module_scss_1.default.content) }, props),
        label && (react_1.default.createElement("label", { htmlFor: forId },
            react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall" }, label))),
        children,
        tipText && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", weight: "book", className: `${form_part_module_scss_1.default.tipText}` }, tipText)),
        errorMsg && (react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", weight: "book", className: `${form_part_module_scss_1.default.errorMsg}` }, errorMsg))));
};
exports.default = FormPart;
//# sourceMappingURL=form-part.js.map